import axios from 'axios'

const state = {
    cost_types: []
};

const actions = {
    getAllCostTypes ({commit}) {
        axios.post('api/expenses/cost_types').then(
            response => {
                commit('recieve_cost_types', response.data)
            }
        ).catch(errors =>{
            console.log(errors);
        })
    },
};

const mutations = {
    recieve_cost_types (state, cost_types) {
        state.cost_types = cost_types;
    },
};

const getters = {
    allCostTypes (state) {
        return state.cost_types
    }
};

export default {
    state,
    actions,
    mutations,
    getters
}
